import { IFunnelRepository } from '../../../domain/repositories/IFunnelRepository';
import { Funnel } from '../../../types';

export class UpdateFunnelUseCase {
    constructor(private funnelRepository: IFunnelRepository) { }

    async execute(id: string, name: string): Promise<void> {
        const funnel: Funnel = { id, name };
        await this.funnelRepository.save(funnel);
    }
}
